import { render, staticRenderFns } from "./extras.vue?vue&type=template&id=558657d4&scoped=true&"
import script from "./extras.vue?vue&type=script&lang=js&"
export * from "./extras.vue?vue&type=script&lang=js&"
import style0 from "./extras.vue?vue&type=style&index=0&id=558657d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558657d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/apps/bowling/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('558657d4')) {
      api.createRecord('558657d4', component.options)
    } else {
      api.reload('558657d4', component.options)
    }
    module.hot.accept("./extras.vue?vue&type=template&id=558657d4&scoped=true&", function () {
      api.rerender('558657d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/extras.vue"
export default component.exports